import { TooltipDirective } from '@/directives/tooltip/tooltip.directive';
import { UserHelper } from '@/helpers/user.helper';
import { AuthenticationService } from '@/services/authentication.service';

import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { AdminService, UserSession } from '@eemo/api-client';
import { Subscription } from 'rxjs';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';

@Component({
  selector: 'app-assumed-user-disconnect',
  templateUrl: './assumed-user-disconnect.component.html',
  styleUrls: ['./assumed-user-disconnect.component.scss'],
  imports: [TooltipDirective, MatIconModule, MatButtonModule],
})
export class AssumedUserDisconnectComponent implements OnInit, OnDestroy {
  private adminService = inject(AdminService);
  private authenticationService = inject(AuthenticationService);
  private dialog = inject(MatDialog);
  private userHelper = inject(UserHelper);

  currentUser: UserSession;
  currentUserDisplay: string;

  currentUserSub = new Subscription();
  assumeSub = new Subscription();
  assumeSessionSub = new Subscription();

  ngOnInit(): void {
    this.currentUserSub = this.authenticationService.currentUser.subscribe((u) => {
      if (u) {
        this.currentUser = u;
        this.currentUserDisplay = this.userHelper.userSessionDisplayName(u);
      }
    });
  }

  ngOnDestroy(): void {
    this.currentUserSub.unsubscribe();
    this.assumeSub.unsubscribe();
    this.assumeSessionSub.unsubscribe();
  }

  confirmStopAssume() {
    // prevents to open multiple dialog
    if (this.dialog.openDialogs.length === 0) {
      const dialogRef = this.dialog.open(ConfirmDialogComponent, {
        // width: '25rem',
        data: {
          message: 'Confirmez-vous le retour en mode admin ?',
        },
      });
      dialogRef.afterClosed().subscribe((result) => {
        if (result) {
          this.doStopAssume();
        }
      });
    }
  }

  doStopAssume() {
    this.assumeSub = this.adminService.adminStopAssumeUser().subscribe(() => {
      this.assumeSessionSub = this.authenticationService.assumeUser().subscribe(() => {
        location.reload();
      });
    });
  }
}
